import { useMutation } from '@tanstack/react-query';
import { api } from '@/services/api';
import type { CampaignMetadata, MetricDefinition } from '@monitoring-panel/types';

interface SuggestWidgetsParams {
  metadata: CampaignMetadata;
  availableColumns: string[];
  availableMetrics: MetricDefinition[];
  campaignData: Array<Record<string, unknown>>;
}

/**
 * Suggest dashboard widgets for a campaign.
 * Prompting + structured generation happen server-side (Gemini); the hook just
 * forwards the campaign context and returns the resulting { widgets, layout }.
 */
export function useAISuggestWidgets() {
  return useMutation({
    mutationFn: (params: SuggestWidgetsParams) => api.ai.suggestWidgets(params),
  });
}
